import React from "react";
import { Menu, Bell, User, LogOut } from "lucide-react";

interface HeaderProps {
  onMenuClick: () => void;
}


const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 sm:px-6 lg:px-8">
      <div className="flex items-center gap-4">
        {/* Mobile Menu Button - Visible ONLY on small screens */}
        <button
          type="button"
          className="rounded-md p-2 text-gray-700 lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Open sidebar</span>
        </button>

        {/* This title is just a placeholder */}
        <h1 className="text-xl font-semibold text-gray-900">Dashboard</h1>
      </div>

      {/* Right-side controls (Notifications, User Menu, Logout) */}
      <div className="flex items-center gap-4">
        <button
          type="button"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        >
          <Bell className="h-6 w-6" />
          <span className="sr-only">View notifications</span>
        </button>

        {/* User Menu */}
        <div className="relative">
          <button className="flex items-center gap-2 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
            <User className="h-8 w-8 rounded-full bg-gray-200 p-1 text-gray-600" />
            <div className="hidden text-left md:block">
              <p className="text-sm font-medium text-gray-700">
                Jyolsna Joemon
              </p>
              <p className="text-xs text-gray-500">jyolsnajoemon@gmail.com</p>
            </div>
          </button>
        </div>

        <button
          type="button"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        >
          <LogOut className="h-6 w-6" />
          <span className="sr-only">Log out</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
